import React, { useMemo } from 'react';
import { isNumber } from 'lodash';
import Skeleton from 'react-loading-skeleton';
import Link from 'next/link';
import { Button, Typography } from '@mui/material';
import { trackEvent } from '@surfline/web-common';

import { getBuoyMapPath, getBuoyMapPathWithLocationObject } from 'utils/urls/mapPaths';

import styles from './NearbyBuoysHeader.module.scss';

export const DEFAULT_MAP_ZOOM = 8;

interface Props {
  loading?: boolean;
  latitude?: number;
  longitude?: number;
  trackLocation?: string;
  spotId?: string;
  spotName?: string;
}

const NearbyBuoysHeader: React.FC<Props> = ({
  loading,
  latitude,
  longitude,
  trackLocation,
  spotId,
  spotName,
}) => {
  const linkText = 'View Map';

  const linkLocation = useMemo(() => {
    if (isNumber(latitude) && isNumber(longitude)) {
      return getBuoyMapPathWithLocationObject({
        center: { lat: latitude, lon: longitude },
        zoom: DEFAULT_MAP_ZOOM,
      });
    }
    return getBuoyMapPath();
  }, [longitude, latitude]);

  const trackClickedViewMap = () => {
    const trackingProps = {
      category: 'buoys',
      location: trackLocation,
      linkName: linkText,
      linkUrl: linkLocation,
      pageName: trackLocation,
      spotId,
      spotName,
    };

    trackEvent('Clicked Link', trackingProps);
  };

  return (
    <header className={styles.nearbyBuoysHeader}>
      <Typography className={styles.nearbyBuoysTitle} variant="title2" mt={10}>
        Nearby Buoys
      </Typography>
      {loading ? (
        <Skeleton width={70} />
      ) : (
        <Link href={linkLocation} passHref>
          <Button variant="secondary" size="medium" onClick={trackClickedViewMap}>
            {linkText}
          </Button>
        </Link>
      )}
    </header>
  );
};

export default NearbyBuoysHeader;
